var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSendButtonIcon = function SvgSendButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00B9B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.279 8.45a.68.68 0 0 1 .68-.069l15.6 7.122-.28.617.28.617-15.6 7.122a.678.678 0 0 1-.954-.697l.678-5.765a.7.7 0 0 1 .13-.327l.713-.95-.712-.95a.7.7 0 0 1-.131-.327l-.678-5.765a.68.68 0 0 1 .274-.628m16 7.67.28.617a.679.679 0 0 0 0-1.234zm-1.634 0-13.152-6.004.516 4.387.907 1.21c.181.241.181.573 0 .814l-.907 1.21-.516 4.387z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.019 14.733a.34.34 0 0 1 .368-.307l14.922 1.356a.339.339 0 0 1 0 .676l-14.922 1.356a.34.34 0 1 1-.061-.675l11.206-1.019-11.206-1.019a.34.34 0 0 1-.307-.368",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.484 8.72a.34.34 0 0 1 .472.084l4.257 6.105a.3.3 0 0 1 .044.086l.339 1.018a.34.34 0 0 1 0 .214l-.34 1.018a.3.3 0 0 1-.043.086l-4.257 6.105a.34.34 0 0 1-.556-.388l4.229-6.064.288-.864-.288-.864L9.4 9.192a.34.34 0 0 1 .084-.472",
    clipRule: "evenodd"
  })));
};
export default SvgSendButtonIcon;